export default __webpack_public_path__ + "static/media/jordanEdwards.32b0a1a6.png";